export const PricingStrategyProfileIds = {
	Default: '00000000-0000-0000-0000-000000000001',
} as const;
